// extracted by mini-css-extract-plugin
export default {"control":"control_control__5VlNM","button":"control_button__dcrvZ"};